(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["angle-3d-calendly-button"] && !window.DesignMode) return;
  try {
    
    const calendlyButtonHTML = `<button class="tda-calendly-btn test2" style="display: inline-block;">Fragen? Jetzt beraten lassen!</button>`;

      window.addEventListener("Angle3DCustomizerLoaded", function(event) {
        if ($( ".tda-customizer-footer-atc-btn" ).length) {
            $( calendlyButtonHTML ).insertAfter( ".tda-customizer-footer-atc-btn" ); 
          $('.tda-calendly-btn').click(() => {
            goToCalendly();                           
          });
        }
      });
  
  function goToCalendly() {
    const win = window.open('https://calendly.com/vitkonwood-beratung/termin', '_blank');
    return false;
  }

  } catch(e) { console.error(e); }
})();
})();
